import { buildTestIds } from "application";
import { LoadingContainer, LoadingContainerProps } from "./styles";

const Loading = ({ ...props }: LoadingContainerProps) => {
  return <LoadingContainer {...buildTestIds("loading-container")} {...props} />;
};

export { Loading };
